<template lang="pug">
.acceso-agua(v-if="hasData")
  .asu-title Internación reciente
  CaracteristicasFisicasEstadistica(:data="chartData", :options="{ pieHole: 0 }")
</template>

<script>
import { mapGetters } from 'vuex'
import { hasData, getData } from '@/utils/object.js'

export default {
  components: {
    CaracteristicasFisicasEstadistica: _ => import('./CaracteristicasFisicasEstadistica')
  },
  computed: {
    ...mapGetters([ 'censo' ]),
    data () {
      return getData(this.censo).internacionReciente
    },
    chartData () {
      if (this.hasData) {
        return [
          [ '', '' ],
          [ 'SI', this.data.si ],
          [ 'NO', this.data.no ]
        ]
      } else {
        return [
          [ '', '' ],
          [ 'SI', 0 ],
          [ 'NO', 0 ]
        ]
      }
    },
    hasData () {
      return hasData(this.data)
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/refugios/statistic'

$top = calc(50% - 36px)
$left = calc(50% - 16px)

.acceso-agua >>>
  .refugio-estadisticas
    .center-icon
      top: $top
      left: $left
</style>
